import { SET_STATUS_BAR, CLEAR_STATUS_BAR } from './constants';

export function clearStatusBar() {
  return {
    type: CLEAR_STATUS_BAR,
  };
}

export function setStatusBar(message, colour) {
  return {
    type: SET_STATUS_BAR,
    message,
    colour,
  };
}



/** WEBPACK FOOTER **
 ** ./src/containers/status-bar/actions.js
 **/